/**
 * Tableaux de bord et exports (cahier §13, ADR-036) : nature des exports,
 * colonnes (limitées au besoin du rapport), formats, statistiques de notes.
 */
export const REPORT_FORMATS = {
    csv: 'CSV (tableur)',
    xlsx: 'Excel (.xlsx)',
    pdf: 'PDF',
};
export const REPORT_KINDS = {
    applications: {
        label: 'Candidatures',
        description: 'Dossiers du concours : matricule, identité, région, statut, paiement.',
        permission: 'candidature.view',
        stage: false,
        sensitive: false,
        columns: [
            'Matricule de candidature',
            'Nom',
            'Prénom',
            'Sexe',
            'Région',
            'Catégorie',
            'Statut du dossier',
            'Déposé le',
            'Paiement',
        ],
    },
    payments: {
        label: 'Paiements',
        description: 'Paiements des frais de candidature (montants, statut, moyen).',
        permission: 'payment.view',
        stage: false,
        sensitive: true,
        columns: [
            'Référence',
            'Matricule de candidature',
            'Nom et prénom',
            'Moyen',
            'Montant',
            'Frais',
            'Total',
            'Devise',
            'Statut',
            'Payé le',
            'Saisie manuelle',
        ],
    },
    results: {
        label: 'Résultats d’une étape',
        description: 'Classement officiel (version approuvée) : rang, note de l’étape, décision.',
        permission: 'results.view',
        stage: true,
        sensitive: true,
        columns: [
            'Rang',
            'Matricule de candidature',
            'Nom',
            'Prénom',
            'Catégorie',
            'Note de l’étape',
            'Décision',
        ],
    },
    grades: {
        label: 'Notes d’une étape',
        description: 'Notes des relevés validés, par discipline et par correction (code d’anonymat tant que l’anonymat n’est pas levé).',
        permission: 'results.view',
        stage: true,
        sensitive: true,
        columns: ['Candidat', 'Discipline', 'Correction', 'Présence', 'Note', 'Barème', 'Évaluateur'],
    },
};
export const REPORT_KIND_CODES = Object.keys(REPORT_KINDS);
export const EXPORT_STATUSES = {
    queued: 'En attente',
    running: 'En cours',
    done: 'Prêt',
    failed: 'Échec',
    expired: 'Expiré',
};
/** Durée de validité du lien de téléchargement (le fichier est ensuite supprimé). */
export const EXPORT_TTL_HOURS = 24;
const round2 = (n) => Math.round(n * 100) / 100;
/** Statistiques descriptives d'une série de notes (valeurs présentes uniquement). */
export function describeScores(values) {
    const v = values.filter((x) => Number.isFinite(x)).toSorted((a, b) => a - b);
    if (!v.length)
        return { count: 0, mean: null, median: null, min: null, max: null, stdev: null };
    const mean = v.reduce((s, x) => s + x, 0) / v.length;
    const mid = Math.floor(v.length / 2);
    const median = v.length % 2 ? v[mid] : (v[mid - 1] + v[mid]) / 2;
    const variance = v.reduce((s, x) => s + (x - mean) ** 2, 0) / v.length;
    return {
        count: v.length,
        mean: round2(mean),
        median: round2(median),
        min: v[0],
        max: v.at(-1),
        stdev: round2(Math.sqrt(variance)),
    };
}
/** Taux en pourcentage arrondi à une décimale (0 si dénominateur nul). */
export const percent = (part, total) => total ? Math.round((part / total) * 1000) / 10 : 0;
/**
 * 🔒 Neutralise l'injection de formule dans un tableur (CSV, Excel) : une
 * valeur commençant par = + - @ (ou tabulation / retour) est préfixée d'une apostrophe.
 */
export function safeCell(value) {
    if (value === null || value === undefined)
        return '';
    const text = String(value);
    return /^[=+\-@\t\r]/.test(text) && !/^-?\d+([.,]\d+)?$/.test(text) ? `'${text}` : text;
}
//# sourceMappingURL=reports.js.map